import { Copy } from 'app/modules/wallforming/components/menu-container/edit-menu/Copy';
import { Cut } from 'app/modules/wallforming/components/menu-container/edit-menu/Cut';
import { Delete } from 'app/modules/wallforming/components/menu-container/edit-menu/Delete';
import { DiscardSelection } from 'app/modules/wallforming/components/menu-container/edit-menu/DiscardSelection';
import { EditGroup } from 'app/modules/wallforming/components/menu-container/edit-menu/EditGroup';
import { Group } from 'app/modules/wallforming/components/menu-container/edit-menu/Group';
import { Paste } from 'app/modules/wallforming/components/menu-container/edit-menu/Paste';
import { Rotate } from 'app/modules/wallforming/components/menu-container/edit-menu/Rotate';
import { SelectAll } from 'app/modules/wallforming/components/menu-container/edit-menu/SelectAll';
import { Transform } from 'app/modules/wallforming/components/menu-container/edit-menu/Transform';
import { Ungroup } from 'app/modules/wallforming/components/menu-container/edit-menu/Ungroup';
import { AutosaveToggle } from 'app/modules/wallforming/components/menu-container/projects-menu/AutosaveToggle';
import { GenerateIfcFromPdfs } from 'app/modules/wallforming/components/menu-container/projects-menu/GenerateIfcFromPdfs';
import { LoadProject } from 'app/modules/wallforming/components/menu-container/projects-menu/LoadProject';
import { SaveProject } from 'app/modules/wallforming/components/menu-container/projects-menu/SaveProject';
import { SaveProjectAs } from 'app/modules/wallforming/components/menu-container/projects-menu/SaveProjectAs';
import { FocusBuilding } from 'app/modules/wallforming/components/menu-container/view-menu/FocusBuilding';
import { LockView } from 'app/modules/wallforming/components/menu-container/view-menu/LockView';

export const MenuActionItem = {
    EditGroup,
    Group,
    Ungroup,
    Delete,
    SelectAll,
    Rotate,
    Transform,
    Cut,
    Copy,
    Paste,
    LockView,
    FocusBuilding,
    DiscardSelection,
    LoadProject,
    SaveProject,
    SaveProjectAs,
    AutosaveToggle,
    GenerateIfcFromPdfs
};
